import React from 'react';
import styles from './course-dates.module.scss';
import { Term } from '../../../models/courses/term';

type Props = {
  terms: Term[];
  programLength: string;
};

const TermStartDate: React.FC<{ term: Term }> = ({ term }) => {
  return <p className='mb-1'>{term.startDateString}</p>;
};

const TermEndDate: React.FC<{ term: Term }> = ({ term }) => {
  return <p className='mb-1'>{term.endDateString}</p>;
};

export default function CourseDates({ terms, programLength }: Props) {
  return (
    <div className={styles['important-dates']}>
      <div className='row'>
        <div className='col-md'>
          {terms.length > 0 && (
            <>
              <h5>Start Date</h5>
              {terms?.map((term) => <TermStartDate key={term.id} term={term} />)}
            </>
          )}
        </div>
        <div className='col-md'>
          {terms.length > 0 && (
            <>
              <h5>End Date</h5>
              {terms?.map((term) => <TermEndDate key={term.id} term={term} />)}
            </>
          )}
        </div>
        <div className='col-md'>
          {programLength && (
            <>
              <h5>Length</h5>
              <p>{programLength}</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
